import Vue from 'vue'
import { Tabs, Collapse, Input, Button, Spin } from 'ant-design-vue'
import '@/components/l8-icon'

Vue.use(Tabs)
Vue.use(Collapse)
Vue.use(Input)
Vue.use(Button)
Vue.use(Spin)
Vue.config.productionTip = false
